import { __asyncGenerator, __await, __generator } from "tslib";
/**
 * Convert ReadableStream into an async iterable.
 */
export function ReadableStreamtoIterable(readableStream) {
    return __asyncGenerator(this, arguments, function ReadableStreamtoIterable_1() {
        var reader, done, _a, end, value;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    done = false;
                    _b.label = 1;
                case 1:
                    if (!!done) return [3 /*break*/, 6];
                    return [4 /*yield*/, __await(reader.read())];
                case 2:
                    _a = _b.sent(), end = _a.done, value = _a.value;
                    if (end) {
                        done = true;
                        return [3 /*break*/, 6];
                    }
                    if (!value) return [3 /*break*/, 5];
                    return [4 /*yield*/, __await(value)];
                case 3: return [4 /*yield*/, _b.sent()];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOztHQUVHO0FBQ0gsTUFBTSxVQUFpQix3QkFBd0IsQ0FDN0MsY0FBOEI7Ozs7OztvQkFFeEIsTUFBTSxHQUFHLGNBQWMsQ0FBQyxTQUFTLEVBQUUsQ0FBQztvQkFDdEMsSUFBSSxHQUFHLEtBQUssQ0FBQzs7O3lCQUNWLENBQUMsSUFBSTtvQkFDbUIsNkJBQU0sTUFBTSxDQUFDLElBQUksRUFBRSxHQUFBOztvQkFBMUMsS0FBdUIsU0FBbUIsRUFBbEMsR0FBRyxVQUFBLEVBQUUsS0FBSyxXQUFBO29CQUN4QixJQUFJLEdBQUcsRUFBRTt3QkFDUCxJQUFJLEdBQUcsSUFBSSxDQUFDO3dCQUNaLHdCQUFNO3FCQUNQO3lCQUNHLEtBQUssRUFBTCx3QkFBSztpREFDRCxLQUFLO3dCQUFYLGdDQUFXOztvQkFBWCxTQUFXLENBQUM7Ozs7Ozs7Q0FHakIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgUmVhZGFibGVTdHJlYW0gaW50byBhbiBhc3luYyBpdGVyYWJsZS5cbiAqL1xuZXhwb3J0IGFzeW5jIGZ1bmN0aW9uKiBSZWFkYWJsZVN0cmVhbXRvSXRlcmFibGU8VD4oXG4gIHJlYWRhYmxlU3RyZWFtOiBSZWFkYWJsZVN0cmVhbVxuKTogQXN5bmNJdGVyYWJsZTxUPiB7XG4gIGNvbnN0IHJlYWRlciA9IHJlYWRhYmxlU3RyZWFtLmdldFJlYWRlcigpO1xuICBsZXQgZG9uZSA9IGZhbHNlO1xuICB3aGlsZSAoIWRvbmUpIHtcbiAgICBjb25zdCB7IGRvbmU6IGVuZCwgdmFsdWUgfSA9IGF3YWl0IHJlYWRlci5yZWFkKCk7XG4gICAgaWYgKGVuZCkge1xuICAgICAgZG9uZSA9IHRydWU7XG4gICAgICBicmVhaztcbiAgICB9XG4gICAgaWYgKHZhbHVlKSB7XG4gICAgICB5aWVsZCB2YWx1ZTtcbiAgICB9XG4gIH1cbn1cbiJdfQ==